/**
 *  Module replacement for abp.notify API.
 */
let _implementation = null;

function showNotification(type, message, title, options) {
    if(typeof _implementation === 'function') {
        _implementation(type, message, title, options);
    }
}

function success(message, title, options) {
    showNotification('success', message, title, options);
}

function info(message, title, options) {
    showNotification('info', message, title, options);
}

function warn(message, title, options) {
    showNotification('warning', message, title, options);
}

function error(message, title, options) {
    showNotification('error', message, title, options);
}

function implementation(notifyImplementation) {
    _implementation = notifyImplementation;
}

export default {
    success,
    info,
    warn,
    error,
    options: {},
    implementation
};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/notify.js